import { isLightTheme } from '@/theme/semanticTokens';
import { lightModeChartStatusColors, uiTokens } from '@/theme/uiTokens';
import type { ThresholdDirection } from '@/features/projects/components/metricThresholds/utils';
import type { Theme } from '@/ui/primitives';

const resolveSliderStatusColors = (theme: Theme): { green: string; orange: string; red: string } =>
  isLightTheme(theme)
    ? lightModeChartStatusColors
    : {
        green: uiTokens.statusColors.green,
        orange: uiTokens.statusColors.orange,
        red: uiTokens.statusColors.red,
      };

export const resolveDisabledSliderRailColor = (theme: Theme): string =>
  isLightTheme(theme) ? lightModeChartStatusColors.neutral : uiTokens.statusColors.neutral;

export const buildSliderGradient = (
  theme: Theme,
  warn: number,
  target: number,
  direction: ThresholdDirection,
): string => {
  const [start, end] = warn <= target ? [warn, target] : [target, warn];
  const sliderStatusColors = resolveSliderStatusColors(theme);
  if (direction === 'lowerBetter') {
    return `linear-gradient(90deg, ${sliderStatusColors.green} 0%, ${sliderStatusColors.green} ${start}%, ${sliderStatusColors.orange} ${start}%, ${sliderStatusColors.orange} ${end}%, ${sliderStatusColors.red} ${end}%, ${sliderStatusColors.red} 100%)`;
  }

  return `linear-gradient(90deg, ${sliderStatusColors.red} 0%, ${sliderStatusColors.red} ${start}%, ${sliderStatusColors.orange} ${start}%, ${sliderStatusColors.orange} ${end}%, ${sliderStatusColors.green} ${end}%, ${sliderStatusColors.green} 100%)`;
};
